import { Box } from "@mui/material";
import { snack } from "components/toast";
import useTitle from "hooks/useTitle";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ResType } from "types";
import EproceedingFya from "views/atom-pro/eProceedingFYA";
import EproceedingFyi from "views/atom-pro/eProceedingFYI";
import { StyledProfileNavItem } from "views/ClientProfile/styles";
import { Permissions } from "data/permissons";
import { usePermissions } from "context/PermissionsProvider";
import AccessDenied from "views/atom-pro/Access/accessDenide";

const IncomeTaxEProceedings = () => {
  useTitle("ATOM Pro | e-Proceedings");
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "FYA";
  const [active, setActive] = useState(defaultTab);
  const { permissions } = usePermissions();

  useEffect(() => {
    setActive(defaultTab);
  }, [defaultTab]);

  const handleTabChange = (tab: string) => {
    setActive(tab);
    setSearchParams({ tab });
  };

  return (
    <>
      <Box
        mb={1}
        display="flex"
        gap="15px"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        bgcolor="#F5F5F5"
      >
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={active === "FYA" ? 1 : 0}
          onClick={() => handleTabChange("FYA")}
          sx={{ marginLeft: "10px" }}
        >
          For Your Action
        </StyledProfileNavItem>
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={active === "FYI" ? 1 : 0}
          onClick={() => handleTabChange("FYI")}
        >
          For Your Information
        </StyledProfileNavItem>
      </Box>

      {active === "FYA" && <EproceedingFya tab="FYA" />}
      {active === "FYI" && <EproceedingFyi tab="FYI" />}
    </>
  );
};
export default IncomeTaxEProceedings;